<template>
  <common-layout-template :isBread="true" :breadHeading="'利用規約'">
    <template v-slot:body>
      <static-contents />
    </template>
  </common-layout-template>
</template>

<script>
import StaticContents from '@/components/static/StaticContentsTerms';
import CommonLayoutTemplate from '@/components/templates/CommonLayoutTemplate';
import MixinMeta from '@/plugins/mixin-meta';

export default {
  name: 'Terms',
  mixins: [MixinMeta],
  components: {
    StaticContents,
    CommonLayoutTemplate,
  },
  data() {
    return {
    };
  },
  created() {
    this.metaSetForDefault('terms');
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@charset "UTF-8";
</style>
